// extracted by mini-css-extract-plugin
export default {"section":"WhatWeDo_section__VO7WQ","inner":"WhatWeDo_inner__+X02m","title":"WhatWeDo_title__odfrV","body":"WhatWeDo_body__TLYcA","link":"WhatWeDo_link__LvVRq"};